import { render } from "./BetCard.vue?vue&type=template&id=6e34ac7c&scoped=true"
import script from "./BetCard.vue?vue&type=script&lang=js"
export * from "./BetCard.vue?vue&type=script&lang=js"

import "./BetCard.vue?vue&type=style&index=0&id=6e34ac7c&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e34ac7c"]])

export default __exports__